import type { Faq } from '../types/content';

export const faqs: Faq[] = [
  // General
  {
    group: 'general',
    question: { en: 'How much does painting cost?', es: '¿Cuánto cuesta la pintura?' },
    answer: {
      en: 'The cost depends on project size, complexity, surface condition, and paint quality. We provide free, detailed estimates within 48 hours.',
      es: 'El costo depende del tamaño del proyecto, su complejidad, el estado de las superficies y la calidad de la pintura. Ofrecemos presupuestos gratuitos y detallados en 48 horas.',
    },
  },
  {
    group: 'general',
    question: { en: 'How long does a painting project take?', es: '¿Cuánto tiempo toma un proyecto de pintura?' },
    answer: {
      en: 'Timeline depends on project size. Small room repaints take 2–3 days. Larger projects take 1–2 weeks. We work around your schedule.',
      es: 'Depende del tamaño del proyecto. Repintar una habitación pequeña toma de 2 a 3 días; los proyectos más grandes, de 1 a 2 semanas. Nos adaptamos a su horario.',
    },
  },
  {
    group: 'general',
    question: { en: 'Are you licensed and insured?', es: '¿Están licenciados y asegurados?' },
    answer: {
      en: 'Yes. Win21der is fully licensed and insured with full liability coverage on every job.',
      es: 'Sí. Win21der cuenta con licencia y seguro completo, con cobertura de responsabilidad en cada trabajo.',
    },
  },
  {
    group: 'general',
    question: { en: 'Do you guarantee your work?', es: '¿Garantizan su trabajo?' },
    answer: {
      en: "Absolutely. If something isn't right, we come back and fix it at no charge. Your satisfaction is our priority.",
      es: 'Por supuesto. Si algo no queda bien, regresamos y lo corregimos sin costo. Su satisfacción es nuestra prioridad.',
    },
  },
  // Commercial
  {
    group: 'commercial',
    question: { en: 'Do you do both interior and exterior commercial painting?', es: '¿Hacen pintura comercial interior y exterior?' },
    answer: {
      en: 'Yes! We specialize in both interior and exterior commercial painting for offices, warehouses, retail, and more.',
      es: '¡Sí! Nos especializamos en pintura comercial interior y exterior para oficinas, almacenes, comercios y más.',
    },
  },
  {
    group: 'commercial',
    question: { en: 'How do you minimize disruption to our business?', es: '¿Cómo minimizan la interrupción a nuestro negocio?' },
    answer: {
      en: 'We schedule work during off-hours, weekends, or evenings if needed. We protect your space and clean up daily.',
      es: 'Programamos el trabajo fuera de horario, en fines de semana o en la noche si es necesario. Protegemos su espacio y limpiamos todos los días.',
    },
  },
  {
    group: 'commercial',
    question: { en: 'Can you handle large industrial projects?', es: '¿Pueden realizar proyectos industriales grandes?' },
    answer: {
      en: 'Absolutely. We have experience with warehouses, high-ceiling work, industrial spaces, and specialized finishes.',
      es: 'Por supuesto. Tenemos experiencia en almacenes, trabajos en techos altos, espacios industriales y acabados especiales.',
    },
  },
  {
    group: 'commercial',
    question: { en: 'Do you offer warranties on commercial work?', es: '¿Ofrecen garantía en trabajos comerciales?' },
    answer: {
      en: 'Yes. We stand behind all commercial work. Our crew takes pride in quality and durability.',
      es: 'Sí. Respaldamos todo nuestro trabajo comercial. Nuestro equipo se enorgullece de la calidad y durabilidad.',
    },
  },
  // Residential
  {
    group: 'residential',
    question: { en: 'Can you paint my whole house or just one room?', es: '¿Pueden pintar toda mi casa o solo una habitación?' },
    answer: {
      en: "We do both! Whether you want to refresh a single room or paint your entire home, we're happy to help.",
      es: '¡Hacemos ambas cosas! Ya sea que quiera renovar una sola habitación o pintar toda su casa, con gusto le ayudamos.',
    },
  },
  {
    group: 'residential',
    question: { en: 'Can you help me choose paint colors?', es: '¿Pueden ayudarme a elegir los colores?' },
    answer: {
      en: 'Yes! Our team has experience with color consultation and can help you select colors that work for your home.',
      es: '¡Sí! Nuestro equipo tiene experiencia en asesoría de color y le ayuda a elegir los colores ideales para su hogar.',
    },
  },
  {
    group: 'residential',
    question: { en: 'Do you do cabinet painting and specialty work?', es: '¿Pintan gabinetes y hacen trabajos especiales?' },
    answer: {
      en: 'Yes! We paint cabinets, doors, trim, decks, fences, and offer specialty finishes throughout your home.',
      es: '¡Sí! Pintamos gabinetes, puertas, molduras, terrazas y cercas, y ofrecemos acabados especiales en toda su casa.',
    },
  },
  {
    group: 'residential',
    question: { en: 'How do you protect my home during painting?', es: '¿Cómo protegen mi casa mientras pintan?' },
    answer: {
      en: 'We use drop cloths, plastic sheeting, and take every precaution to protect your furniture, floors, and landscaping.',
      es: 'Usamos lonas, plástico protector y tomamos todas las precauciones para proteger sus muebles, pisos y jardín.',
    },
  },
  // Estimates & areas
  {
    group: 'more',
    question: { en: 'What areas do you serve?', es: '¿Qué áreas atienden?' },
    answer: {
      en: 'We serve Columbus and surrounding areas: Dublin, Westerville, Hilliard, Grove City, Gahanna, Reynoldsburg, and Worthington.',
      es: 'Atendemos Columbus y sus alrededores: Dublin, Westerville, Hilliard, Grove City, Gahanna, Reynoldsburg y Worthington.',
    },
  },
  {
    group: 'more',
    question: { en: 'How do I get a free estimate?', es: '¿Cómo obtengo un presupuesto gratuito?' },
    answer: {
      en: "Contact us by phone (614-382-9458), email, or through our contact form. We'll schedule a visit and provide a detailed written estimate within 48 hours.",
      es: 'Contáctenos por teléfono (614-382-9458), correo electrónico o nuestro formulario. Programaremos una visita y le entregaremos un presupuesto escrito y detallado en 48 horas.',
    },
  },
  {
    group: 'more',
    question: { en: 'Can you match paint colors?', es: '¿Pueden igualar los colores de pintura?' },
    answer: {
      en: 'Yes! We can match existing colors or help you select new ones. Our experts help you choose colors that work for your space.',
      es: '¡Sí! Podemos igualar los colores existentes o ayudarle a elegir nuevos. Nuestros expertos le ayudan a escoger los colores ideales para su espacio.',
    },
  },
  {
    group: 'more',
    question: { en: 'What makes Win21der different?', es: '¿Qué hace diferente a Win21der?' },
    answer: {
      en: "We're locally owned, professional, and focused on customer satisfaction. We serve both commercial and residential clients with the same attention to detail and quality.",
      es: 'Somos una empresa local, profesional y enfocada en la satisfacción del cliente. Atendemos a clientes comerciales y residenciales con la misma atención al detalle y calidad.',
    },
  },
];
